module.exports = __webpack_public_path__ + "img/sheepValue.27488e96.png";